import { country } from "./ocm-object";
import type { CurrencyCode } from "@ocm/global-types";

const LOCALES: Record<typeof country, string> = {
	de: "de-DE",
	at: "de-AT",
	ch: "de-CH",
	int: "en-GB",
};
const CURRENCY: CurrencyCode = country === "ch" ? "CHF" : "EUR";
const CURRENCY_SYMBOLS: Record<CurrencyCode, "CHF" | "€"> = {
	CHF: "CHF",
	EUR: "€",
};

const priceFormatter = new Intl.NumberFormat(LOCALES[country], {
	useGrouping: false,
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});
export const formatPrice = (price: number | string, currency: CurrencyCode = CURRENCY) => {
	// currency symbol should always be displayed before the price, no matter the country's formatting standard
	return `${CURRENCY_SYMBOLS[currency]} ${priceFormatter.format(Number(price))}`;
};

export const formatDiscount = (percentage: number | string) => `-${Math.floor(Math.abs(Number(percentage)))}%`;

const numberFormatter = new Intl.NumberFormat(LOCALES[country]);
export const formatNumber = (number: number | string) => numberFormatter.format(Number(number));
